<template>
	<div>
		<el-tabs v-model="tabName">
			<el-tab-pane label="ការកំណត់គណនីដាក់ប្រាក់" name="first"></el-tab-pane>
			<el-tab-pane label="ការកំណត់ប្រភេទដកប្រាក់" name="second"></el-tab-pane>

		</el-tabs>

		<div v-if="tabName == 'first' && $store.state.authentication.account_type == 'sa'">
			<md-table>
				<md-table-row>
					<md-table-head>ល.រ</md-table-head>
					<md-table-head>ប្រភេទដាក់ប្រាក់</md-table-head>
					<md-table-head>លេខគណនី USD</md-table-head>
					<md-table-head>ឈ្មោះគណនី USD</md-table-head>
					<md-table-head>លេខគណនី KHR</md-table-head>
					<md-table-head>ឈ្មោះគណនី KHR</md-table-head>
				</md-table-row>
				<md-table-row v-for="(setting, index) in method_deposit">
					<md-table-cell>{{index + 1}}</md-table-cell>
					<md-table-cell>
						<md-field>
							<md-input type="text" v-model="method_deposit[index].type"
								:value="method_deposit[index].type" @keyup="">
							</md-input>
						</md-field>
					</md-table-cell>
					<md-table-cell>
						<md-field>
							<md-input type="text" v-model="method_deposit[index].account_usd"
								:value="method_deposit[index].account_usd" @keyup="">
							</md-input>
						</md-field>
					</md-table-cell>
					<md-table-cell>
						<md-field>
							<md-input type="text" v-model="method_deposit[index].account_name_usd"
								:value="method_deposit[index].account_name_usd" @keyup="">
							</md-input>
						</md-field>
					</md-table-cell>
					<md-table-cell>
						<md-field>
							<md-input type="text" v-model="method_deposit[index].account_khr"
								:value="method_deposit[index].account_khr" @keyup="">
							</md-input>
						</md-field>
					</md-table-cell>
					<md-table-cell>
						<md-field>
							<md-input type="text" v-model="method_deposit[index].account_name_khr"
								:value="method_deposit[index].account_name_khr" @keyup="">
							</md-input>
						</md-field>
					</md-table-cell>
					<md-table-cell>
						<md-button class="md-just-icon md-simple md-success" @click="updateDeposit(index)">
							<md-icon>done</md-icon>
							<md-tooltip md-direction="top">កែប្រែ</md-tooltip>
						</md-button>
						<!-- <md-button class="md-just-icon md-simple md-danger" @click="deleteDeposit(index)">
							<md-icon>delete</md-icon>
							<md-tooltip md-direction="top">លុប</md-tooltip>
						</md-button> -->
					</md-table-cell>
				</md-table-row>
				<!-- <md-table-row>
					<md-table-cell>បន្ថែមថ្មី</md-table-cell>
					<md-table-cell>
						<md-field>
							<label>ប្រភេទបង់ប្រាក់</label>
							<md-input type="text" v-model="deposit.type" :value="deposit.type"></md-input>
						</md-field>
					</md-table-cell>
					<md-table-cell>
						<md-field>
							<label>លេខគណនី</label>
							<md-input type="text" v-model="deposit.account" :value="deposit.account"></md-input>
						</md-field>
					</md-table-cell>
					<md-table-cell>
						<md-field>
							<label>ឈ្មោះគណនី</label>
							<md-input type="text" v-model="deposit.account_name" :value="deposit.account_name"></md-input>
						</md-field>
					</md-table-cell>
					<md-table-cell>
						<md-button class="md-just-icon md-simple md-success" @click="createDeposit()">
							<md-icon>add_circle</md-icon>
							<md-tooltip md-direction="top">បង្កើតថ្មី</md-tooltip>
						</md-button>
					</md-table-cell>
				</md-table-row> -->
			</md-table>
		</div>
		<div v-if="tabName == 'second'">
			<!-- <md-table v-if="method_withdraw.length > 0">
				<md-table-row>
					<md-table-head>ល.រ</md-table-head>
					<md-table-head>គណនី</md-table-head>
					<md-table-head>សមតុល្យទឹកប្រាក់</md-table-head>
					<md-table-head>សកម្មភាព</md-table-head>
				</md-table-row>

				<md-table-row v-for="(setting, index) in method_withdraw">
					<md-table-cell>{{ index + 1 }}</md-table-cell>
					<md-table-cell><b>{{setting.type }}</b></md-table-cell>
					<md-table-cell><b>{{setting.balance}}</b></md-table-cell>
					<md-table-cell>
						<router-link :to="'/referrals/detail/' + setting.id">
							<md-button class="md-just-icon md-simple md-primary">
								<md-icon>visibility</md-icon>
								<md-tooltip md-direction="top">បង្ហាញបន្ថែម</md-tooltip>
							</md-button>
						</router-link>
					</md-table-cell>
				</md-table-row>
			</md-table> -->
			<md-table>
				<md-table-row>
					<md-table-head>ល.រ</md-table-head>
					<md-table-head>ប្រភេទដកប្រាក់</md-table-head>
					<md-table-head></md-table-head>
					<md-table-head>សមតុល្យទឹកប្រាក់</md-table-head>
					<md-table-head>សកម្មភាព</md-table-head>
				</md-table-row>
				<md-table-row v-for="(setting, index) in method_withdraw">
					<md-table-cell>{{index + 1}}</md-table-cell>
					<md-table-cell>
						<md-field>
							<md-input type="text" v-model="method_withdraw[index].type"
								:value="method_withdraw[index].type" @keyup="">
							</md-input>
						</md-field>
					</md-table-cell>
					<md-table-cell>
						<md-button class="md-just-icon md-simple md-success" @click="updateWithdraw(index)">
							<md-icon>done</md-icon>
							<md-tooltip md-direction="top">កែប្រែ</md-tooltip>
						</md-button>
					</md-table-cell>
					<md-table-cell><b>{{config.moneylify(setting.balance)}}</b></md-table-cell>
					<md-table-cell>

						<router-link :to="'/settings/topup/' + setting.id">
							<md-button class="md-just-icon md-simple md-success">
								<md-icon>currency_exchange</md-icon>
								<md-tooltip md-direction="top">បន្ថែមទឹកប្រាក់</md-tooltip>
							</md-button>
						</router-link>
					</md-table-cell>

				</md-table-row>
				<!-- <md-table-row>
					<md-table-cell>បន្ថែមថ្មី</md-table-cell>
					<md-table-cell>
						<md-field>
							<label>ប្រភេទដកប្រាក់</label>
							<md-input type="text" v-model="withdraw.type" :value="withdraw.type"></md-input>
						</md-field>
					</md-table-cell>
					<md-table-cell>
						<md-button class="md-just-icon md-simple md-success" @click="createWithdraw()">
							<md-icon>add_circle</md-icon>
							<md-tooltip md-direction="top">បង្កើតថ្មី</md-tooltip>
						</md-button>
					</md-table-cell>
				</md-table-row> -->
			</md-table>
		</div>
		<!-- <md-dialog-confirm :md-active.sync="deleteDialogActive" md-title="Are you sure want to delete this ticket ?"
			md-content="By clicking OK this ticket will be deleted from the database and this action can not be undone."
			md-confirm-text="OK" md-cancel-text="Cancel" @md-cancel="onCancel" @md-confirm="onDelete" /> -->
	</div>

</template>

<script>

	export default {

		created() {
			this.getSettings();
		},
		data() {
			return {
				isValid: true,
				tabName: 'first',
				packageTypeList: [],
				deposit: {
					type: "",
					account: "",
					account_name: ""
				},
				withdraw: {
					type: ""
				},
				method_deposit: [],
				method_withdraw: []
			}
		},
		methods: {
			getSettings() {
				this.$http.get(this.config.api + "/admin/setting/data/get_all").then(data => {
					this.method_deposit = data.body.data.method_deposit
					this.method_withdraw = data.body.data.method_withdraw
				})
			},
			updateDeposit(index) {
				if(this.method_deposit[index].type.length > 0 && this.method_deposit[index].account_usd.length > 0 && this.method_deposit[index].account_name_usd.length > 0 && this.method_deposit[index].account_khr.length > 0 && this.method_deposit[index].account_name_khr.length > 0) {
					this.$http.post(this.config.api + "/admin/setting/deposit/update", {
						id: this.method_deposit[index].id,
						type: this.method_deposit[index].type,
						account_usd: this.method_deposit[index].account_usd,
						account_name_usd: this.method_deposit[index].account_name_usd,
						account_khr: this.method_deposit[index].account_khr,
						account_name_khr: this.method_deposit[index].account_name_khr
					}).then(res => {
						if (res.body.status == 'success') {
							this.$notification.notify({
								message: "វិធីដាក់ប្រាក់ត្រូវបានកែប្រែដោយជោគជ័យ។",
								icon: 'done',
								type: 'success'
							})
							this.getSettings();
						}
					})
				} else {
					this.$notification.notify({
						message: "សូមបំពេញព័ត៌មាន។",
						icon: 'error',
						type: 'danger'
					})
				}

			},
			deleteDeposit(index) {
				this.$http.post(this.config.api + "/admin/setting/deposit/delete", {
					id: this.method_deposit[index].id
				}).then(res => {
					if (res.body.status == 'success') {
						this.$notification.notify({
							message: "វិធីដាក់ប្រាក់ត្រូវបានលុបដោយជោគជ័យ។",
							icon: 'done',
							type: 'success'
						})
						this.getSettings();
					}
				})
			},
			createDeposit() {
				if(this.deposit.type.length > 0 && this.deposit.account.length > 0 && this.deposit.account_name.length > 0) {
					this.$http.post(this.config.api + "/admin/setting/deposit/post", {
						type: this.deposit.type,
						account: this.deposit.account,
						account_name: this.deposit.account_name,
					}).then(res => {
						if (res.body.status == 'success') {
							this.$notification.notify({
								message: "វិធីដាក់ប្រាក់ត្រូវបានបង្កើតដោយជោគជ័យ។",
								icon: 'done',
								type: 'success'
							})
							this.deposit.type = "";
							this.deposit.account = "";
							this.deposit.account_name = "";
							this.getSettings();
						}
					})
				} else {
					this.$notification.notify({
						message: "សូមបំពេញព័ត៌មាន។",
						icon: 'error',
						type: 'danger'
					})
				}
			},
			updateWithdraw(index) {
				if(this.method_withdraw[index].type.length > 0) {
					this.$http.post(this.config.api + "/admin/setting/withdraw/update", {
						id: this.method_withdraw[index].id,
						type: this.method_withdraw[index].type
					}).then(res => {
						if (res.body.status == 'success') {
							this.$notification.notify({
								message: "វិធីដកប្រាក់ត្រូវបានកែប្រែដោយជោគជ័យ។",
								icon: 'done',
								type: 'success'
							})
							this.getSettings();
						}
					})
				} else {
					this.$notification.notify({
						message: "សូមបំពេញព័ត៌មាន។",
						icon: 'error',
						type: 'danger'
					})
				}

			},
			deleteWithdraw(index) {
				this.$http.post(this.config.api + "/admin/setting/withdraw/delete", {
					id: this.method_withdraw[index].id
				}).then(res => {
					if (res.body.status == 'success') {
						this.$notification.notify({
							message: "វិធីដកប្រាក់ត្រូវបានលុបដោយជោគជ័យ។",
							icon: 'done',
							type: 'success'
						})
						this.getSettings();
					}
				})
			},
			createWithdraw() {
				if(this.withdraw.type.length > 0) {
					this.$http.post(this.config.api + "/admin/setting/withdraw/post", {
						type: this.withdraw.type
					}).then(res => {
						if (res.body.status == 'success') {
							this.$notification.notify({
								message: "វិធីដកប្រាក់ត្រូវបានបង្កើតដោយជោគជ័យ។",
								icon: 'done',
								type: 'success'
							})
							this.withdraw.type = "";
							this.getSettings();
						}
					})
				} else {
					this.$notification.notify({
						message: "សូមបំពេញព័ត៌មាន។",
						icon: 'error',
						type: 'danger'
					})
				}
			}

		}
	}
</script>

<style scoped>
	.grid-8 {
		text-align: center;
		max-width: 12.5%;
		min-width: 12.5%;
		flex: 0 0 12.5%;
	}

	.thumb-product {
		width: 100%;
	}

	.product-thumbnail {
		width: 100px;
		height: 100px;
	}

	.vdatetime-input {
		border: 0;
		width: 100%;
		height: 32px;
	}

	.vdatetime {
		width: 100%;
	}
</style>



// WEBPACK FOOTER //
// src/pages/Settings/View.vue